<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <!-- //espaço em branco// -->
            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>
                    <li style="padding-left: 15px;" class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Colaboradores</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>
        </div>
        <div id="pnlista">
            <!-- Botão Novo empresa -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-person-plus"></i> Novo colaborador
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pesquisa empresa  -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model.number="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tabela de colaboradores -->
            <div class="card">
                <div class="card-body">
                    <!-- Tabela de colaboradores com EasyDataTable -->
                    <EasyDataTable :headers="headers" :items="lstcolaboradores" :pagination="false" hide-footer
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id }">
                            <div style="display: flex; justify-content: center;">
                                <a @click="mtdalterar(id)" class="btn btn-sm btn-warning">
                                    <i class="bi bi-pencil-square"></i>
                                </a>
                                <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-danger"
                                    @click="mtdexcluir(id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </template>
                        <template #item-nome="{ tipo, nome }">
                            {{ nome }}
                        </template>
                        <template #item-documento="{ nome, tipo, cpfcnpj }">
                            <span>{{ cpfcnpj }}</span>
                        </template>
                        <template #item-ativo="{ ativo }">
                            <span :class="['badge', parseInt(ativo) === 0 ? 'text-bg-secondary' : 'text-bg-success']">{{ parseInt(ativo) === 0 ? 'Inativo' : 'Ativo' }}</span>
                        </template>

                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <!-- Cadastro de colaboradores -->
            <div class="card">
                <div class="card-header">
                    <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item">
                            <a  class="nav-link active" data-bs-toggle="tab" href="#dadosGerais">Dados colaborador</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#endereco">Endereço</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#cargo">Cargo</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#acesso">Acesso</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#imagens">Imagens</a>
                        </li>

                        
                    </ul>
                </div>
                <div class="card-body tab-content">
                   
                    <div class="tab-pane fade show active" id="dadosGerais">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edid">Código</label>
                                        <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                    </div>
                                </div>
                                <div class="col-lg-10">
                                    <div class="form-group">
                                        <label for="ednome">Nome</label>
                                        <input type="text" v-model="vnome" :disabled="ativadesativa" class="form-control" id="ednome">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edcnpjcpf">CPF</label>
                                        <MaskInput type="text" mask="###.###.###-##" :disabled="ativadesativa"
                                            class="form-control" v-model="vcpfcnpj" id="edcnpjcpf" />
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edpis">PIS/PASEP</label>
                                        <input type="text" v-model="vpispasep" :disabled="ativadesativa" class="form-control" id="edpis">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edrg">Registro geral (RG)</label>
                                        <input type="text" v-model="vrg" :disabled="ativadesativa" class="form-control" id="edrg">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="ednacionalidade">Nacionalidade</label>
                                        <input type="text" v-model="vnacionalidade" :disabled="ativadesativa" class="form-control" id="ednacionalidade">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="ednaturalidade">Naturalidade</label>
                                        <input type="text" v-model="vnaturalidade" :disabled="ativadesativa" class="form-control" id="ednaturalidade">
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="edfone1">Fone 1</label>
                                        <MaskInput type="text" mask="(##) # ####-####" :disabled="ativadesativa"
                                            class="form-control" v-model="vfone1" id="edfone1" />
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="edfone2">Fone 2</label>
                                        <MaskInput type="text" mask="(##) # ####-####" :disabled="ativadesativa"
                                            class="form-control" v-model="vfone2" id="edfone2" />
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="edemail">Email:</label>
                                        <input type="text" v-model="vemail" :disabled="ativadesativa" class="form-control" id="edemail">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="eddatanasc">Data de Nascimento</label>
                                        <input type="date" v-model="dtnascimento" :disabled="ativadesativa" class="form-control" id="eddatanasc">
                                    </div>
                                </div>
                                
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edgenero">Gênero</label>
                                        <select v-model="vgenero" class="form-select" id="edgenero">
                                            <option value="0">Selecione</option>
                                            <option value="1">Masculino</option>
                                            <option value="2">Feminino</option>
                                            <option value="3">Outro</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label for="edestadocivil">Estado Civil</label>
                                        <select v-model="vestadocivil" class="form-select" id="edestadocivil">
                                            <option value="0">Selecione</option>
                                            <option value="1">Solteiro</option>
                                            <option value="2">Casado</option>
                                            <option value="3">Divorciado</option>
                                            <option value="4">Viúvo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="eddtadmissao">Data de admissão</label>
                                        <input type="date" v-model="vdtadimicao" :disabled="ativadesativa" class="form-control" id="eddtadmissao">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="edativo">Situação</label>
                                        <select v-model="vativo" class="form-select" id="edativo">
                                            <option value="1">Ativo</option>
                                            <option value="0">Inativo (desligado)</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <span class="lblselect2">Filial:</span>
                                    <select id="cbempresa" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidempresa">
                                    </select>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="endereco">
                        <div class="container">
                           <div class="row">
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="edcep">*Cep:</label>
                                    <MaskInput type="text" mask="#####-###" v-model="vcep" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edcep" maxlength="9"/>
                                </div>
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <label for="edlogradouro">*Endereço:</label>
                                    <input type="text" v-model="vlogradouro" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edlogradouro" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednrendereco">*Nº Endereço:</label>
                                    <input type="text" v-model="vnrendereco" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="ednrendereco" maxlength="20"
                                        style="text-transform: uppercase;">
                                </div> 
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="edcomplementoend">Complemento:</label>
                                    <input type="text" v-model="vcomplementoend" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edcomplementoend" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="edperimetroend">Perímetro:</label>
                                    <input type="text" v-model="vperimetroend" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edperimetroend" maxlength="100"
                                        style="text-transform: uppercase;">
                                </div>                                                        
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <label for="cbbairro">*Bairro:</label>
                                    <select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione uma opção" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <label for="cbmunicipio">*Município:</label>
                                    <select id="cbmunicipio" v-model="vidmunicipio"
                                            v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione uma opção" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbuf">*Estado:</label>
                                    <select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
                                            data-placeholder="Selecione a uf" data-allow-clear="true"
                                            style="width:100%;">
                                    </select>
                                </div>                                            
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="cargo">
                        <div class="container">
                            <div class="row">
                                
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <span class="lblselect2">Grupo/Setor:</span>
                                    <select id="cbgrupo" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidgrupo">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <span class="lblselect2">Subgrupo:</span>
                                    <select id="cbsubgrupo" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidsubgrupo">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <span class="lblselect2">Função:</span>
                                    <select id="cbfuncao" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidfuncao">
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3">
                                    <span class="lblselect2">Jornada:</span>
                                    <select id="cbjornada" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidjornada">
                                    </select>
                                </div>
                                
                            </div>

                            <!-- Escala: vigência da jornada e início do ciclo (sábado alternado, 12x36...) -->
                            <div class="row mt-3 escala-colab">
                                <div class="col-sm-12 col-md-4" v-if="opcrud == 2 && jornadaAlterada">
                                    <div class="form-group">
                                        <label for="edjornadadesde">Nova jornada vale a partir de</label>
                                        <input type="date" v-model="vjornada_desde" :disabled="ativadesativa" class="form-control" id="edjornadadesde">
                                        <small class="text-muted">Em branco = hoje. Os dias anteriores continuam com a jornada antiga.</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="form-group">
                                        <label for="eddtbaseciclo">Início do ciclo da escala</label>
                                        <input type="date" v-model="vdtbase_ciclo" :disabled="ativadesativa" class="form-control" id="eddtbaseciclo">
                                        <small class="text-muted">Só para escala alternada ou revezamento. Ex.: um sábado em que o colaborador trabalha, ou o dia do 1º plantão do 12x36.</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 d-flex align-items-center" v-if="vid">
                                    <router-link :to="'/escalas?colaborador=' + vid" class="btn btn-light">
                                        <i class="bi bi-calendar-week"></i> Ver escala, histórico e exceções
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="acesso">
                        <div class="container">
                            <div class="row">
                                <!-- Conteúdo da aba Acesso -->
                                <div class="col-lg-4">
                                    <label for="cbtipoacesso">Ponto por aplicativo</label>
                                    <select class="form-select form-control" v-model="vpontoaplicativo"
                                        aria-label="Default select example">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                    </select>   
                                </div>

                                <div class="col-lg-4">
                                    <label for="edpontotablet">Ponto no relógio itinerante (tablet)</label>
                                    <select class="form-select form-control" v-model="vpontotablet" id="edpontotablet">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                    </select>
                                </div>

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="eddsenha">Senha do ponto {{ vtemsenha ? '(cadastrada)' : '' }}</label>
                                        <input type="password" v-model="vsenha" :disabled="ativadesativa" class="form-control" id="eddsenha"
                                            inputmode="numeric" autocomplete="new-password" :placeholder="vtemsenha ? 'deixe em branco para manter' : 'de preferência só números'">
                                        <small class="text-muted">Usada no app e no teclado do relógio itinerante.</small>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <span class="lblselect2">Zona/Perimetro:</span>
                                    <select id="cbzona" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidzona">
                                    </select>
                                </div>

                 

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="cbtipoacesso">Ponto por whatsapp</label>
                                        <select class="form-select form-control" v-model="vpontozap">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-4 d-flex align-items-end" v-if="vpontozap == '1'">
                                    <button type="button" @click="mtdabrirmodalZAP()" class="btn btn-success w-100">
                                        <i class="bi bi-whatsapp"></i> Configurar WhatsApp
                                    </button>
                                </div>
                      
                                
                            </div>
                        </div>

                    </div>

                    <div class="tab-pane fade" id="imagens">
                        <div class="container">
                            <p class="ck-subtitulo mb-2">
                                Fotos usadas no reconhecimento facial do app e do relógio itinerante.
                                Use fotos de frente, com boa luz e só o rosto do colaborador (2 a 3 fotos é o ideal).
                            </p>

                            <div v-if="parseInt(opcrud) < 3"
                                 :class="['area-upload', { arrastando: arrastandoImg, enviando: enviandoImg }]"
                                 @click="$refs.if_imgcolab.click()"
                                 @dragenter.prevent="arrastandoImg = true"
                                 @dragover.prevent="arrastandoImg = true"
                                 @dragleave.prevent="arrastandoImg = false"
                                 @drop.prevent="mtdsoltarimagens">
                                <input type="file" id="ipselecionarimg" ref="if_imgcolab" multiple
                                       accept="image/png, image/jpeg, image/webp" style="display: none;"
                                       @change="mtdselecionarimagem">
                                <template v-if="!enviandoImg">
                                    <i class="bi bi-cloud-arrow-up"></i>
                                    <strong>Arraste as fotos para cá ou clique para escolher</strong>
                                    <small>Pode selecionar várias de uma vez · JPG, PNG ou WEBP · até 8 MB cada</small>
                                </template>
                                <template v-else>
                                    <div class="progress w-75" style="height: 8px;">
                                        <div class="progress-bar" :style="{ width: progressoImg + '%', background: 'var(--ck-primaria)' }"></div>
                                    </div>
                                    <small class="mt-2">Enviando {{ qtdEnviandoImg }} foto(s)… {{ progressoImg }}%</small>
                                </template>
                            </div>

                            <div v-if="lstImagens.length > 0" class="grade-fotos">
                                <div v-for="(imagem, index) in lstImagens" :key="imagem.patharquivo" class="foto">
                                    <img :src="pathimgview + imagem.patharquivo + '?v=' + versaoImg" :alt="'Foto ' + (index + 1)">
                                    <button v-if="parseInt(opcrud) < 3" type="button" class="excluir-foto" title="Excluir foto"
                                            @click.prevent="mtdexcluirimg(imagem.patharquivo)"><i class="bi bi-trash"></i></button>
                                </div>
                            </div>
                            <p v-else class="text-center text-muted small mt-3">Nenhuma foto cadastrada.</p>
                        </div>
                    </div>
                </div>
           
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">
                                <!--// espaço vazio //-->
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-info">
                                    <i class="bi bi-edit"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-warning">
                                    <i class="bi bi-edit"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-danger">
                                    <i class="bi bi-edit"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal de Mapa -->
        <div class="modal fade"  ref="modalzap" tabindex="-1" aria-labelledby="modalzapLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalzapLabel">Configuração</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                      <div class="modal-body">
                        <div class="row mb-4">
                            <div class="col-12">
                                <label class="form-label">Adicionar Novo Número</label>
                                <div class="input-group">
                                    <input type="text" 
                                        v-model="vnovo_numero_zap" 
                                        class="form-control" 
                                        placeholder="Ex: 5511999999999"
                                        @keyup.enter="mtdAdicionarNumeroLista">
                                    <button class="btn btn-info" type="button" @click="mtdAdicionarNumeroLista">
                                        <i class="bi bi-plus-lg"></i>
                                    </button>
                                </div>
                                <small class="text-muted">Pressione Enter ou clique no + para adicionar.</small>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-12">
                                <label class="form-label">Números Configurados</label>
                                <ul class="list-group">
                                    <li v-for="(item, index) in listarzap" :key="index" 
                                        class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>
                                            <i class="bi bi-whatsapp text-success me-2"></i>
                                            {{ item.numero }}
                                        </span>
                                        <button class="btn btn-sm btn-outline-danger" @click="mtdRemoverNumeroLista(index)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </li>
                                    <li v-if="listarzap.length === 0" class="list-group-item text-center text-muted small">
                                        Nenhum número adicionado ainda.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      


    </div>
</template>

<script>
// @ is an alias to /src

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';
import { ref } from "vue";
import MaskInput from '@/components/MaskInput.vue';
import { Modal, Tab } from "bootstrap";



const onClickHandler = (page) => {
  console.log(page);
};

const pagina_atual = ref(1);



export default {
    name: 'empresa',

    data() {
        return {
            //variaveis do cadastro 
            opcrud              : 0,
            vid                 : 0,
            vtipo               : 0,
            vnome               : '',
            vcpfcnpj            : '',
            vpispasep           : '',
            vrg                 : '',
            vnacionalidade      : '',
            vnaturalidade       : '',
            vfone1              : '',
            vfone2              : '',
            vemail              : '',
            dtnascimento        : '',
            vgenero             : 0,
            vestadocivil        : 0,
            vidempresa          : null,
            vcep                : '', 
            vlogradouro         : '',
            vnrendereco         : '',
            vcomplementoend     : '',
            vperimetroend       : '',
            vidbairro           : null, 
            vidmunicipio        : null,
            viduf               : null,
            vidgrupo            : null,
            vidsubgrupo         : null,
            vidfuncao           : null,
            vidjornada          : null,
            vidjornada_original : null,
            vjornada_desde      : '',
            vdtbase_ciclo       : '',
            vidzona             : null,
            vsenha              : '',
            vtemsenha           : false,
            vdtadimicao         : '',
            vativo              : '1',
            vpontotablet        : '1',
            vpontoaplicativo    : '1',
            vpontozap           : '1', 
            vnovo_numero_zap    : '',
        

            arqimgselecionado    : null,
            lstImagens           : [],
            arrastandoImg        : false,
            enviandoImg          : false,
            progressoImg         : 0,
            qtdEnviandoImg       : 0,
            versaoImg            : 0,
            pathimgview          : util.servidor +'/',   





            modulo              : 'COLABORADORES',
            descop              : '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual        : 1,
            pqtdregistros       : 10,
            pqtd_paginas        : 0,



            ModalMenu: null,


            //filtros
            pfiltro             : 1,
            pconteudo           : '',

            ativadesativa       : false,

            headers: [
                { 
                    text    : 'Ações',   
                    value   : 'acoes', 
                    sortable: false, 
                    width: 80 
                },
                { 
                    text    : 'Nome',    
                    value   : 'nome', 
                    sortable: true 
                },
                { 
                    text    : 'CPF', 
                    value   : 'cpfcnpj', 
                    sortable: true 
                },
                { text: 'Filial', value: 'nomefilial', sortable: true },
                { text: 'Jornada', value: 'nomejornada', sortable: true },
                { text: 'Situação', value: 'ativo', sortable: true },
            ],
            lstcolaboradores: [],
            listarzap: [],
        }
    },
    components: {
        EasyDataTable,
        MaskInput,
    },
    methods: {
        mtdRemoverNumeroLista(index){
            let vself = this;


            let dados = vself.listarzap[index];

             Swal.fire({
                title: "Confirmação",
                text: 'Confirma exclusão do numero?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                      let parametros = [
                            { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                            { parametro: 'op',            valor: 'deletarnumero' },
                            { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                            { parametro: 'idcolaborador', valor: dados.idcolaborador },
                            { parametro: 'numero',        valor: dados.numero },
                           
                        ];
                        let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
                        retorno.then(function (response) {
                        if ($.isNumeric(response.data)) {
                                util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                            
                                vself.mtdlistarnumeros();
                                
                            } else {
                                let tpret = response.data.substring(0, 1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif('error', 'Informação!', response.data.substring(4));
                                        break;
                                    case 'E': default:
                                        util.notif('error', 'Informação!', response.data.substring(4));
                                        break;
                                }
                            }
                        }).catch(function (response) {
                            alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
                        });
                    
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdAdicionarNumeroLista(){
            let vself = this;
                     
            let parametros = [
                { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',            valor: 'cadastranumero' },
                { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                { parametro: 'idcolaborador', valor: vself.vid },
                { parametro: 'numero',        valor: vself.vnovo_numero_zap },
                { parametro: 'servidor',      valor: util.servidor },
          
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
             if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                   
                    vself.mtdlistarnumeros();
                    vself.vnovo_numero_zap = '';
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });

        },
        mtdlistarnumeros(){
            let vself = this;
         
            let parametros = [
                { parametro: 'idusuario',     valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',            valor: 'listarzap' },
                { parametro: 'idempresa',     valor: vself.$store.state.usuario.idempresa },
                { parametro: 'idcolaborador', valor: vself.vid },
                { parametro: 'servidor',      valor: util.servidor },
          
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.listarzap = response.data;

            }).catch(function (response) {
               
            });
        },
        async mtdabrirmodalZAP(){


            await this.mtdlistarnumeros();


            this.ModalMenu = new Modal(this.$refs.modalzap);

            // 1. Abre o modal do Bootstrap
            this.ModalMenu.show();

        },
        mtdexcluirimg(patharquivo){
            let vself = this;
            vself.$loading.show();
            let localarquivo = 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa +'/'+ vself.vpathimagens;

            let parametros      = [
            {parametro: 'op',               valor  : "excluirarquivo"},
            {parametro: 'patharquivo',      valor  : patharquivo},
            {parametro: 'idempresa',        valor  : vself.$store.state.usuario.idempresa },
            {parametro: 'localarquivo',     valor  : localarquivo}

            ];
            let retorno     = util.reqaxios(parametros, 'post',  util.servidor+'/controller/utilitario.php');
            retorno.then(function (response) {
            if ($.isNumeric(response.data.inf)){
                util.notif('success', 'Informação!', 'Imagem excluída com sucesso!');
                vself.lstImagens = [];
                vself.lstImagens = vself.mtdordenaimagens(response.data.arquivos);
            }else{
                util.notif('error', 'Erro!', (response.data && response.data.inf) || String(response.data).replace(/^E - /, ''));
            }
                vself.$loading.hide();
            }).catch(function (response) {
                vself.$loading.hide();
                util.notif('error', 'Erro!', 'Descrição do erro: '+response.message);
            });
        },
        mtdordenaimagens(lstimagens){
                let lstordenada = (lstimagens || []).slice().sort((a, b) =>
                    String(a.arquivo).localeCompare(String(b.arquivo), undefined, { numeric: true }));
                return lstordenada;
        },
        mtdselecionarimagem(event){
            this.mtdenviarimagens(Array.from(event.target.files || []));
            event.target.value = '';
        },
        mtdsoltarimagens(event){
            this.arrastandoImg = false;
            this.mtdenviarimagens(Array.from((event.dataTransfer && event.dataTransfer.files) || []));
        },
        async mtdenviarimagens(arquivos){
            const vself = this;
            const validos = arquivos.filter(a => /^image\/(jpeg|png|webp)$/.test(a.type));
            const recusados = arquivos.length - validos.length;
            const grandes = validos.filter(a => a.size > 8 * 1024 * 1024);
            const enviar = validos.filter(a => a.size <= 8 * 1024 * 1024);
            if (recusados || grandes.length) {
                util.notif('error', 'Atenção', [
                    recusados ? recusados + ' arquivo(s) ignorado(s): envie apenas JPG, PNG ou WEBP.' : '',
                    grandes.length ? grandes.length + ' foto(s) acima de 8 MB ignorada(s).' : '',
                ].join(' '));
            }
            if (!enviar.length) return;
            if (!vself.vpathimagens) vself.vpathimagens = util.GerarStringAleatoria();

            const parametros = [
                { parametro: 'localsalvar', valor: 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa + '/' + vself.vpathimagens },
                { parametro: 'autonumerar', valor: '1' },
            ];
            enviar.forEach(a => parametros.push({ parametro: 'arquivos[]', valor: a }));

            vself.enviandoImg = true;
            vself.qtdEnviandoImg = enviar.length;
            vself.progressoImg = 0;
            const timer = setInterval(() => { if (vself.progressoImg < 90) vself.progressoImg += 10; }, 200);
            try {
                const response = await util.reqaxios(parametros, 'post', util.servidor + '/controller/uploadfile.php');
                const d = response.data || {};
                if (Array.isArray(d.arquivos)) {
                    vself.lstImagens = vself.mtdordenaimagens(d.arquivos);
                    vself.versaoImg++;
                }
                if (d.enviados > 0 && (!d.erros || !d.erros.length)) {
                    util.notif('success', d.enviados + ' foto(s) enviada(s)', '');
                } else if (d.enviados > 0) {
                    util.notif('error', d.enviados + ' foto(s) enviada(s)', 'Algumas falharam: ' + d.erros.join('; '));
                } else {
                    util.notif('error', 'Não foi possível enviar', typeof d === 'string' ? d.replace(/^E - /, '') : (d.inf || 'Erro no envio.'));
                }
            } catch (e) {
                util.notif('error', 'Não foi possível enviar', 'Falha de comunicação com o servidor.');
            } finally {
                clearInterval(timer);
                vself.progressoImg = 100;
                vself.enviandoImg = false;
            }

        },
        mtdpesquisacep(){
            let vself = this;
            let cepinf = vself.vcep;
            if ( cepinf != ''){
                if (util.IsCEP(cepinf, '')){
                    vself.$loading.show();
                    let parametros = [
                        {parametro: 'param1', 		valor  : 'consultarcep'},
                        {parametro: 'idempresa',    valor  : vself.$store.state.usuario.idempresa },
                        {parametro: 'cep', 			valor  : cepinf}
                    ];
                    let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/buscarcep.php');
                    retorno.then(function (response) {
                         vself.$loading.hide();
                        if (response.data != '0') {
                            var defmun            = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                            $('#cbmunicipio').append(defmun).trigger('change');

                            var defbai            = new Option(response.data.descbairro, response.data.idbairro, true, true);
                            $('#cbbairro').append(defbai).trigger('change');

                            var defuf             = new Option(response.data.descuf, response.data.iduf, true, true);
                            $('#cbuf').append(defuf).trigger('change');

                            vself.vlogradouro     = response.data.logradouro;
                            vself.vreferencia     = response.data.complemento;
                        }else{
                            util.notif('error', 'Atenção!', 'CEP inválido ou inexistente!');
                        }					

                    }).catch(function (response) {
                        vself.$loading.hide();
                        console.log(response.message);
                    });
                }
            }                
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : JSON.stringify({ campo: 'id', valor: this.pconteudo });
            } else {
                rfiltro = this.pconteudo === '' ? '' : JSON.stringify({ campo: 'nome', valor: this.pconteudo });
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',        valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself  = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioimagens',  valor: 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: vself.pqtdregistros },
                { parametro: 'offset',    valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.lstcolaboradores = JSON.parse(JSON.stringify(response.data));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstcolaboradores = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
        },
        resetarDados() {
            this.vid                = '';
            this.vnome              = '';
            this.vcpfcnpj           = '';
            this.vtipo              = 0;
            this.vpispasep          = '';
            this.vrg                = '';
            this.dtnascimento       = '';
            this.vgenero            = 0;
            this.vestadocivil       = 0;
            this.vnacionalidade     = '';
            this.vnaturalidade      = '';
            this.vfone1             = '';
            this.vfone2             = '';
            this.vemail             = '';
            this.vcep               = '';
            this.vlogradouro        = '';
            this.vnrendereco        = '';
            this.vcomplementoend    = '';
            this.vperimetroend      = '';
            this.vidempresa         = null;
            this.viduf              = null;
            this.vidbairro          = null;
            this.vidmunicipio       = null;
            this.vidgrupo           = null;
            this.vidsubgrupo        = null;
            this.vidfuncao          = null;
            this.vidjornada         = null;
            this.vidjornada_original = null;
            this.vjornada_desde     = '';
            this.vdtbase_ciclo      = '';
            this.vidzona            = null;
            this.vpontoaplicativo   = 1;
            this.vpontotablet       = 1;
            this.vativo             = 1;
            this.vdtadimicao        = '';
            this.vtemsenha          = false;
            this.vsenha             = '';

            this.vpathimagens       = '';

            this.lstImagens         = [];
            this.arqimgselecionado  = null;
            this.enviandoImg        = false;
            this.progressoImg       = 0;
            this.qtdEnviandoImg     = 0;
            this.listarzap          = [];
            this.vnovo_numero_zap   = '';

            // Remove as opções carregadas do registro anterior (não só desmarca).
            ['#cbempresa', '#cbuf', '#cbbairro', '#cbmunicipio', '#cbgrupo', '#cbsubgrupo',
             '#cbfuncao', '#cbjornada', '#cbzona'].forEach(function (sel) {
                $(sel).empty().val(null).trigger('change');
            });

            // Sempre começa na primeira aba.
            const primeiraAba = document.querySelector('#pncadastro a[href="#dadosGerais"]');
            if (primeiraAba) Tab.getOrCreateInstance(primeiraAba).show();

            
        
        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {
            this.descop = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);
            this.vpathimagens = util.GerarStringAleatoria();
        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();
        },
        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                    vself.mtdregistro();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = JSON.stringify({ campo: 'id', valor: id });
            let parametros = [
                { parametro: 'op', valor: 'listagem' },
                { parametro: 'idusuario',         valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa',         valor: vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioimagens',  valor: 'imagens/imagenscolaboradores/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',            valor: filtro },
                { parametro: 'limit',             valor: 1 },
                { parametro: 'offset',            valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {
            this.descop = 'ALTERAÇÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);
        },
        mtdexcluir(id) {
            this.descop = 'EXCLUSÃO'
            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);
        },
        /** Seleciona um valor no select2 só quando existe (evita a opção "null"). */
        mtdselect2(seletor, id, texto) {
            $(seletor).empty();
            if (id !== null && id !== undefined && id !== '' && id !== 0 && id !== '0') {
                $(seletor).append(new Option(texto || ('Código ' + id), id, true, true));
            }
            $(seletor).trigger('change');
        },
        mtdigualarcampos(registro) {
            this.vid                = registro.id;
            this.vnome              = registro.nome;
            this.vtipo              = registro.tipo;
            this.vcpfcnpj           = registro.cpfcnpj;
            this.vpispasep          = registro.pispasep;
            this.vrg                = registro.rg;
            this.dtnascimento       = registro.dtnascimento;
            this.vgenero            = registro.genero;
            this.vestadocivil       = registro.estadocivil;
            this.vnacionalidade     = registro.nacionalidade;
            this.vnaturalidade      = registro.naturalidade;
            this.vfone1             = registro.fone1;
            this.vfone2             = registro.fone2;
            this.vemail             = registro.email;
            this.vcep               = registro.cep;
            this.vlogradouro        = registro.logradouro;
            this.vnrendereco        = registro.numero;
            this.vcomplementoend    = registro.complemento;
            this.vperimetroend      = registro.perimetroend;
            this.vpontoaplicativo   = registro.pontoaplicativo === null ? 1 : registro.pontoaplicativo;
            this.vpontotablet       = registro.pontotablet === undefined || registro.pontotablet === null ? 1 : registro.pontotablet;
            this.vativo             = registro.ativo === undefined ? 1 : registro.ativo;
            this.vdtadimicao        = registro.dtadimicao || '';
            this.vtemsenha          = !!registro.temsenha;
            this.vsenha             = '';

            this.vpathimagens       = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();


            this.lstImagens              = this.mtdordenaimagens(registro.imagens);

            // Empresa
            this.vidempresa = registro.idfilialpadrao;
            this.mtdselect2('#cbempresa', registro.idfilialpadrao, registro.nomefilial);

            // UF
            this.viduf = registro.iduf;
            this.mtdselect2('#cbuf', registro.iduf, registro.descuf);

            // Bairro
            this.vidbairro = registro.idbairro;
            this.mtdselect2('#cbbairro', registro.idbairro, registro.descbairro);

            // Município
            this.vidmunicipio = registro.idmunicipio;
            this.mtdselect2('#cbmunicipio', registro.idmunicipio, registro.descmunicipio);

            // Grupo
            this.vidgrupo = registro.idgrupo;
            this.mtdselect2('#cbgrupo', registro.idgrupo, registro.nomegrupo);

            // Subgrupo
            this.vidsubgrupo = registro.idsubgrupo;
            this.mtdselect2('#cbsubgrupo', registro.idsubgrupo, registro.nomesubgrupo);

            // Função
            this.vidfuncao = registro.idfuncao;
            this.mtdselect2('#cbfuncao', registro.idfuncao, registro.nomefuncao);

            // Jornada
            this.vidjornada = registro.idjornada;
            this.vidjornada_original = registro.idjornada;
            this.vjornada_desde = '';
            this.vdtbase_ciclo = registro.dtbase_ciclo || '';
            this.mtdselect2('#cbjornada', registro.idjornada, registro.nomejornada);

            // Zona
            this.vidzona = registro.idzona;
            this.mtdselect2('#cbzona', registro.idzona, registro.nomezona);

        
        },
        mtdregistro() {
            let vself = this;
            let registrocrud = {
                'id'              : this.vid,
                'nome'            : this.vnome,
                'cpfcnpj'         : this.vcpfcnpj.replace(/\D/g, ""),
                'tipo'            : this.vtipo, 
                'pispasep'        : this.vpispasep,
                'rg'              : this.vrg,
                'nacionalidade'   : this.vnacionalidade,
                'naturalidade'    : this.vnaturalidade,
                'fone1'           : this.vfone1,
                'fone2'           : this.vfone2,
                'email'           : this.vemail,
                'dtnascimento'    : this.dtnascimento,
                'genero'          : this.vgenero,
                'estadocivil'     : this.vestadocivil,
                'idempresa'       : this.vidempresa,
                'cep'             : this.vcep,
                'logradouro'      : this.vlogradouro,
                'nrendereco'      : this.vnrendereco,
                'complementoend'  : this.vcomplementoend,
                'perimetroend'    : this.vperimetroend,
                'idbairro'        : this.vidbairro,
                'idmunicipio'     : this.vidmunicipio,
                'iduf'            : this.viduf,
                'idgrupo'         : this.vidgrupo,
                'idsubgrupo'      : this.vidsubgrupo,
                'idfuncao'        : this.vidfuncao,
                'idjornada'       : this.vidjornada,
                'jornada_desde'   : this.jornadaAlterada ? this.vjornada_desde : '',
                'dtbase_ciclo'    : this.vdtbase_ciclo,
                'pathimagens'     : this.vpathimagens,
                'senha'           : this.vsenha,
                'pontoaplicativo' : this.vpontoaplicativo,
                'pontotablet'     : this.vpontotablet,
                'ativo'           : this.vativo,
                'dtadimicao'      : this.vdtadimicao,
                'idzona'          : this.vidzona,

            };
            let parametros = [
                { parametro: 'op',        valor: 'rotinacrud' },
                { parametro: 'opcrud',    valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro',  valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/colaboradores.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },
    },
    computed:{
        jornadaAlterada(){
            return this.vidjornada != null && String(this.vidjornada) !== String(this.vidjornada_original);
        },
        validou(){
            return this.vnome == '' || this.vcpfcnpj == '' || this.vidjornada == null || this.vrg == '' || this.vnacionalidade ==  '' ||
            this.vnaturalidade == '' || this.vfone1 == '' || this.vemail == '' || this.dtnascimento == '' || this.vidempresa == null || 
            this.vcep == ''

                   
        }
    },
    mounted() {
        let vself = this;
        $loading.show()
        setTimeout(() => {
            this.$loading.hide()
            this.mtdexecutapesquisa();
        }, 1000)
        $('#pncadastro').hide();

        $("#edcep").blur(function(){
            vself.mtdpesquisacep();
        });

           //selects da consulta
        $("#cbempresa").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfiliais ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidempresa = $("#cbempresa").val();
        });

        $("#cbgrupo").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbgrupos ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidgrupo = $("#cbgrupo").val();
        });

        
        $("#cbsubgrupo").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbsubgrupos ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidsubgrupo = $("#cbsubgrupo").val();
        });

        
        $("#cbfuncao").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfuncoes ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidfuncao = $("#cbfuncao").val();
        });

        
        // (inicialização duplicada de #cbfuncao removida)


          
        $("#cbmunicipio").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbmunicipios ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidmunicipio = $("#cbmunicipio").val();
        });


        $("#cbbairro").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbbairros ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidbairro = $("#cbbairro").val();
        });


        $("#cbuf").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, descricao from tbufs ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'descricao'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.viduf = $("#cbuf").val();
        });

        $("#cbjornada").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbjornadas ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap', 
            language: "pt-BR",
            templateResult: util.formatResult,  
            templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidjornada = $("#cbjornada").val();
                });

        $("#cbzona").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbzonas ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap', 
            language: "pt-BR",
            templateResult: util.formatResult,  
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidzona = $("#cbzona").val();
        });        

    },
    watch:{
        pagina_atual(val){
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>

.pagination-container {
    display: flex;

    column-gap: 10px;
  }

  .paginate-buttons {
  

    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #13534a;

    border: 1px solid #13534a;

    color: white;
  }

  .active-page:hover {
    background-color: #13534a;
  }

</style><style scoped>
.area-upload {
    border: 2px dashed var(--ck-borda);
    border-radius: 14px;
    background: #f8faf9;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color .15s, background .15s;
}
.area-upload i { font-size: 2.2rem; color: var(--ck-primaria); }
.area-upload strong { font-size: .95rem; }
.area-upload small { color: var(--ck-texto-2); }
.area-upload:hover, .area-upload.arrastando { border-color: var(--ck-primaria); background: var(--ck-primaria-suave); }
.area-upload.enviando { cursor: progress; }
.grade-fotos { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 12px; margin-top: 16px; }
.foto { position: relative; aspect-ratio: 1; border-radius: 12px; overflow: hidden; background: #eef3f1; box-shadow: var(--ck-sombra); }
.foto img { width: 100%; height: 100%; object-fit: cover; }
.excluir-foto {
    position: absolute; top: 6px; right: 6px; width: 30px; height: 30px; border-radius: 8px; border: 0;
    background: rgba(255, 255, 255, .92); color: var(--ck-perigo); display: grid; place-items: center;
    opacity: 0; transition: opacity .15s;
}
.foto:hover .excluir-foto, .excluir-foto:focus { opacity: 1; }
@media (hover: none) { .excluir-foto { opacity: 1; } }
</style>
